<template>
  <div class="c-service-logo">
    <img
      :src="serviceLogo"
      :alt="serviceName"
      class="c-service-logo__img"
      v-if="serviceLogo"
    />
  </div>
</template>

<script>
import commons from "@/common/store/modules/commons";
import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";
import AuthApi from "@/general/api/authApi";

@Component({
  computed: {
    ...mapState({
      //#59042�Ή��ɂ��Z�b�V������񂩂�page_logo���擾����悤�ɏC��
      //serviceLogo: () => commons.serviceLogo,
      serviceLogo: () => this.service_logo,
      serviceName: () => commons.serviceName
    })
  }
})
export default class ServiceLogo extends Vue {

  service_logo = "";

  //#59042�Ή��ɂ��Z�b�V������񂩂�page_logo���擾����悤�ɏC��
  async created() {
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.service_logo = ic_session.pageLogo;
    })
    .catch(() => {
      this.service_logo = "";
    });
  }
}
</script>

<style lang="scss" scoped>
.c-service-logo {
  &__img {
    display: block;
  }
}
</style>
